var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserOutline = function SvgUserOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M12.5 6.071a2.5 2.5 0 1 0-5 0 2.5 2.5 0 1 0 5 0m1.429 0A3.93 3.93 0 0 1 10 10a3.93 3.93 0 0 1-3.929-3.929A3.93 3.93 0 0 1 10 2.143a3.93 3.93 0 0 1 3.929 3.928M5 14.745c0 .674-.057.612.326.612h9.706c.382 0 .325.062.325-.612 0-1.634-2.36-2.602-5.178-2.602S5 13.11 5 14.745m-1.429 0c0-2.772 3.071-4.03 6.608-4.03s6.607 1.258 6.607 4.03c0 1.44-.558 2.04-1.754 2.04H5.326c-1.197 0-1.755-.6-1.755-2.04"
  })));
};
export default SvgUserOutline;